<script>
import { mapActions, mapGetters } from "vuex";
import Global from "@/constants/Global.js";
import groupPrivacy from "@/enum/group-privacy";
export default {
  methods: {
    ...mapActions([
      "getMyGroups",
      "getAllGroups",
      "getGroupSearch",
      "fetchGroup",
      "fetchMembers",
      "fetchItems",
      "fetchMessages",
      "fetchComments",
      "setNewGroupMembers",
      "inviteMember",
      "createNewGroup",
      "resetNewGroup",
      "joinGroup",
      "fetchMyModeratedGroups",
      "fetchJoinRequests",
      "emptyInviteResponses",
      "fetchGroupsYouMayLike",
      "sendGroupMessage",
      "sendGroupComment",
      "newRequestToJoin",
      "fetchGroupMembers",
      "fetchModerator",
      "leaveGroup",
      "resetGroupImage",
      "saveGroupImage",
      "removeGroupImage",
      "removeMember",
      "validateGroupId",
      "resetCurrentGroup",
      "fetchMembershipsProfile",
      "updateGroupSettings",
      "fetchModeratorInvitees",
      "assignModerator",
      "getGroupModeratorInvitations",
      "assignModeratorCancel"
    ]),
    getGroupImagePath(group) {
      if (group && group.id) {
        return `${Global.getServerDomain()}/images/group/${group.id}.jpg`;
      }
      return `${Global.getServerDomain()}/images/group/1.jpg`;
    },
    getGroupName(group) {
      if (group && group.name) return `${group.name}`;
      return "Undefined name";
    },
    getGroupDescription(group) {
      if (group && group.description) return `${group.description}`;
      return "Undefined description";
    },
    getModeratorName(group) {
      if (group) {
        if (group.firstName) return group.firstName;
        if (group.username) return group.username;
        if (group.moderator) return `${group.moderator}`;
      }
      return "No moderator";
    },
    getModeratorImagePath(moderator) {
      if (moderator && moderator.id) {
        return `${Global.getServerDomain()}/images/user/${moderator.id}.jpg`;
      }
      return `${Global.getServerDomain()}/images/user/2.jpg`;
    },
    getGroupHeaderImg(id) {
      if (id) return `${Global.getServerDomain()}/images/group/header/${id}`;
      return `${Global.getServerDomain()}/images/group/header/1`;
    },
    getGroupPrivacy(group) {
      if (group === undefined || group.privacy === undefined) {
        return "";
      } else if (group.privacy === groupPrivacy.PUBLIC) return "Public";
      else if (group.privacy === groupPrivacy.PRIVATE) return "Private";
      else if (group.privacy === groupPrivacy.HIDDEN) return "Hidden";
    },
  },
  computed: {
    ...mapGetters({
      getCurrentGroup: "getCurrentGroup",
      getCurrentGroupMembers: "getCurrentGroupMembers",
      getCurrentGroupTimeline: "getCurrentGroupTimeline",
      getCurrentGroupItems: "getCurrentGroupItems",
      getCurrentGroupMessages: "getCurrentGroupMessages",
      getCurrentGroupComments: "getCurrentGroupComments",
      getNewGroupMembers: "getNewGroupMembers",
      newGroup: "getNewGroup",
      newGroupId: "getCreateNewGroupResponse",
      myGroups: "getMyGroups",
      myModeratedGroups: "getMyModeratedGroups",
      getJoinInvitations: "getJoinInvitations",
      getJoinRequests: "getJoinRequests",
      inviteMembersResponse: "getInviteMembersResponse",
      groupsYouMayLIke: "getGroupsYouMayLIke",
      groupMessages: "getGroupMessages",
      getModerator: "getModerator",
      getValidationGroupResponse: "getValidGroupResponse",
      getCurrentUserProfileMemberships: "getCurrentUserProfileMemberships",
    }),
  },
};
</script>
